import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'portals-customer-carousel',
	templateUrl: './customer-carousel.component.html',
	styleUrls: ['./customer-carousel.component.scss'],
})
export class CustomerCarouselComponent implements OnInit {
	@Input() slides = [
		{
			title: 'Octavius Moore',
			subtitle: 'Chair, Technology | Executive Committee Member',
			comment: '“It’s not lost on us that as technology and the world progresses that our methods must also evolve. Jotto has allowed us to modernize our advocacy work, expand our reach, and foster direct connections with individuals who are passionate about making their voices heard. This tool was critical in driving our 2022 campaigns’ success.”',
			imageSrc: '/assets/images/carousel-Octavius-Moore.jpeg',
			companyImage: '/assets/images/naacp-white.png'
		},
		{
			title: 'Cate Graney LMSW Director',
			subtitle: 'Home Based Crisis Intervention and Graduate Student Programs',
			comment: '"Over the course of the year, we received more than 550 students responses via Jotto! Our increased touch points with students created a stronger sense of connection and increased our channels of communication."',
			imageSrc: '/assets/images/carousel-Cate-Graney-LMSW-Director.jpeg',
			companyImage: '/assets/images/university-settlement-white.png'
		},
		{
			title: 'Doug Binette',
			subtitle: 'Executive Director, NY Tech Alliance',
			comment: '“Big shout out to Jotto! Their platform enables us to engage with attendees before, during and after our NY Tech Meetup events allowing them to easily share their thoughts, ideas and feedback. We especially love the voice and video recording options that help people share more of what they’re thinking vs old school survey systems that make it a tedious experience.”',
			imageSrc: '/assets/images/carousel-Doug-Binette.png',
			companyImage: '/assets/images/nyta-white.png'
		},
		{
			title: 'Donald S. Pollard',
			subtitle: 'President, Impact Mentors Foundation',
			comment: '“Jotto has been instrumental for the Impact Mentors Foundation, transforming how we engage with amazing entrepreneurs in underserved ecosystems. It’s not just a tool; it’s our bridge to truly understanding and empowering these communities.”',
			imageSrc: '/assets/images/carousel-Donald-S.-Pollard.png',
			companyImage: '/assets/images/impact-mentors-foundation-white.png'
		},
		{
			title: 'Luiz Aragon',
			subtitle: 'Principal, LEAD4 LLC',
			comment: '“Thanks to Jotto, we’re not just reaching more people; we’re understanding them better. It’s been a game-changer for our community initiatives.”',
			imageSrc: '/assets/images/carousel-Luiz-Aragon.png',
			companyImage: '/assets/images/bcw-white.png'
		},
		{
			title: 'John-Paul Parmigiani',
			subtitle: 'CEO & Co-Founder, Impact Hub New York Metropolitan Area',
			comment: '"I believe the Jotto team has innovated a product that can improve the quality of life and vibrancy of community through a smarter and more authentic platform for participation - whether for 100 people or 100 million people"',
			imageSrc: '/assets/images/carousel-John-Paul-Parmigiani.webp',
			companyImage: '/assets/images/impact-hub-white.png'
		},
	];
	currentSlideIndex = 0;
	autoSlideInterval: any;
	fade = false;
  
	goToSlide(index: number): void {
	  this.fade = true;
	  this.currentSlideIndex = index;
	}
	ngOnInit() {
		// Start auto sliding after 5 seconds
		this.startAutoSlide(5000);
	}

	nextSlide() {
		this.fade = false; // Start with fade set to false
		setTimeout(() => {
			this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length; // Update currentSlideIndex
			this.fade = true; // Set fade to true after a brief delay
		}, 50); // Add a slight delay before setting fade to true
		this.resetAutoSlide(); // Reset auto slide interval
	}

	prevSlide() {
		this.fade = false; // Start with fade set to false
		setTimeout(() => {
			this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length; // Update currentSlideIndex
			this.fade = true; // Set fade to true after a brief delay
		}, 50); // Add a slight delay before setting fade to true
		this.resetAutoSlide(); // Reset auto slide interval
	}

	startAutoSlide(interval: number) {
		this.autoSlideInterval = setInterval(() => {
			this.nextSlide();
		}, interval);
	}

	resetAutoSlide() {
		clearInterval(this.autoSlideInterval);
		this.startAutoSlide(5000); // Restart auto sliding after each manual slide change
	}
	// Add an event listener for animation end
	animationEndHandler(event: AnimationEvent) {
		if (event.animationName === 'fadeInOut') {
			this.fade = false; // Remove the fade class after animation completes
		}
	}
}
